"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Region = Region;
const React = __importStar(require("react"));
const registry_1 = require("./registry");
const regionRouter_1 = require("./regionRouter");
const RegionPathContext = React.createContext("");
class RegionBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { failed: false, resetKey: this.props.resetKey };
    }
    static getDerivedStateFromError() {
        return { failed: true };
    }
    static getDerivedStateFromProps(props, state) {
        if (props.resetKey !== state.resetKey) {
            return { failed: false, resetKey: props.resetKey };
        }
        return null;
    }
    componentDidCatch(error) {
        // eslint-disable-next-line no-console
        console.error(`[plugin-ui] an op on region "${this.props.regionId}" threw; using core default`, error);
    }
    render() {
        return this.state.failed ? this.props.fallback : this.props.children;
    }
}
const subscribeRegistry = (fn) => registry_1.pluginRegistry.onChange(fn);
const getRegistryVersion = () => registry_1.pluginRegistry.version();
/** A plugin-extensible UI region. */
function Region({ cls, id, ctx, children, }) {
    const parentPath = React.useContext(RegionPathContext);
    const registryVersion = React.useSyncExternalStore(subscribeRegistry, getRegistryVersion, getRegistryVersion);
    const localId = id !== null && id !== void 0 ? id : cls;
    const fullId = parentPath ? `${parentPath}/${localId}` : localId;
    // Regions re-render per board piece per battle turn, so we memoize the descriptor and ops to avoid unnecessary re-renders of ops consumers.
    const descriptor = React.useMemo(() => ({ id: fullId, classes: [cls] }), [fullId, cls]);
    const ops = React.useMemo(() => regionRouter_1.regionRouter.resolveRegion(descriptor), 
    // resolveRegion's output changes when plugins (re)register, which also bumps the version.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [descriptor, registryVersion]);
    if (!regionRouter_1.regionRouter.hasUiOps) {
        return React.createElement(React.Fragment, null, children);
    }
    const hasOps = !!ops.remove ||
        !!ops.replace ||
        ops.wraps.length > 0 ||
        ops.augmentBefore.length > 0 ||
        ops.augmentAfter.length > 0 ||
        ops.transforms.length > 0;
    if (!hasOps) {
        return (React.createElement(RegionPathContext.Provider, { value: fullId }, children));
    }
    const composed = (0, regionRouter_1.composeRegion)(ops, children, ctx, descriptor);
    return (React.createElement(RegionPathContext.Provider, { value: fullId },
        React.createElement(RegionBoundary, { regionId: fullId, resetKey: `${fullId}|${registryVersion}`, fallback: children }, composed)));
}
